module.exports = __webpack_public_path__ + "media/images/homes/KitchenPrinters-90cfaae3aecb119407103eb7431025e8.png";